var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgHelpOctagon = function (props) { return (_jsxs("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: [_jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M11.873 2.063H6.128L2.063 6.128v5.745l4.065 4.065h5.745l4.065-4.065V6.128z" }), _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.031 6.761a2.143 2.143 0 0 1 4.121.817C11.153 9.563 9 9.189 9 10.876v.375" }), _jsx("path", { fill: "currentColor", d: "M9 13.875a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5" })] }))); };
export default SvgHelpOctagon;
